export default __webpack_public_path__ + "static/media/eye-closed.597719fa.svg";